import React from 'react';
import classes from './ComingSoon.module.css';
import LiefMan from 'assets/images/liefIcons/no-logs-selected.png';

const ComingSoon = () => {
  return (
    <div className={classes.ComingSoonContainer}>
      <img src={LiefMan} alt="Coming Soon" />
      <h1>Coming Soon</h1>
    </div>
  );
};

export default ComingSoon;
